module.exports = __webpack_public_path__ + "img/attach.55979481.svg";